import type { HTMLAttributes } from 'react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type DiverpIdrops = HTMLAttributes<HTMLDivElement> & {
  orientation?: 'horizontal' | 'vertical';
};

export const Divider: React.FC<DiverpIdrops> = ({ orientation = 'horizontal', className, ...props }) => {
  return (
    <div
      className={twMerge(
        'flex bg-[#DFEBF1]',
        orientation === 'vertical' ? 'h-full w-px' : 'h-px w-full',
        className,
      )}
      {...props}
    />
  );
};
